import React, { useState } from "react";
import "./PaymentsDues.css";
import { IoEyeOutline } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Dropdown from "react-bootstrap/Dropdown";
import { IoClose } from "react-icons/io5";
import { GoSearch } from "react-icons/go";

function createData1(
  date,
  source,
  counterParty,
  invoice,
  orderValue,
  paid,
  balance,
  status,
) {
  return {
    date,
    source,
    counterParty,
    invoice,
    orderValue,
    paid,
    balance,
    status,
  };
}

const rows1 = [
  createData1(
    "12-Sep-2025",
    "Sub-distributor Order",
    "Vijay Paints",
    "INV-2025-312",
    "₹45,000",
    "₹0",
    "₹45,000",
    "Pending",
  ),
  createData1(
    "12-Sep-2025",
    "Sub-distributor Order",
    "Vijay Paints",
    "INV-2025-312",
    "₹45,000",
    "₹0",
    "₹45,000",
    "Pending",
  ),
  createData1(
    "12-Sep-2025",
    "Sub-distributor Order",
    "Vijay Paints",
    "INV-2025-312",
    "₹45,000",
    "₹0",
    "₹45,000",
    "Overdue",
  ),
  createData1(
    "12-Sep-2025",
    "Sub-distributor Order",
    "Vijay Paints",
    "INV-2025-312",
    "₹45,000",
    "₹0",
    "₹45,000",
    "Paid",
  ),
];

export const PaymentDues = () => {
  const navigate = useNavigate();
  const [selectedLabel, setSelectedLabel] = useState("");
  const [show, setShow] = useState(false);
  const [filterToggler, setFilterToggler] = useState("");

  function handleClearFilters() {
    setFilterToggler("");
    setSelectedLabel("");
  }
  return (
    <div className="ordersContainer">
      <div className="container">
        <div className="inventoryTitle">Payments & Dues</div>
        <div className="inventorySubtitle">
          Track payments linked directly to Orders (from Sub-distributors) and
          POS Sales (Retail).
        </div>
        {/* cards section  */}
        <div className="paymentCardsGrid">
          <div className="inventoryCard">
            <div>Total Paid</div>
            <div>0</div>
          </div>
          <div className="inventoryCard">
            <div>Total Unpaid</div>
            <div>0</div>
          </div>
          <div className="inventoryCard">
            <div>Overdue Payments (30+ days)</div>
            <div style={{ color: "#EF4444" }}>0</div>
          </div>

          <div className="inventoryCard">
            <div>POS Sales</div>
            <div>0</div>
          </div>
        </div>
        {/* filters  */}
        <div className="searchMainContainer">
          <div className="searchSubContainer">
            <div className="searchGrid">
              <div>
                <input type="text" placeholder="Search" />
              </div>
              <div style={{ display: "flex", gap: "5px" }}>
                <div>
                  <GoSearch className="searchIcon" />
                </div>
                <div className="btnRestSearch">
                  <button>Reset</button>
                </div>
              </div>
            </div>
            <div>
              <div className="dropdownTitle">Filter by</div>
              <Dropdown>
                <Dropdown.Toggle
                  className="btnDropdownProduct"
                  id="dropdown-basic"
                >
                  {filterToggler || "All"}
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item onClick={() => setFilterToggler("")}>
                    All
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => setFilterToggler("Payment Type")}
                  >
                    Payment Type
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => setFilterToggler("Status")}>
                    Status
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
            <div>
              <div className="dropdownTitle">Date Range</div>
              <Dropdown show={show} onToggle={() => setShow(!show)}>
                <Dropdown.Toggle
                  className="btnDropdownProduct"
                  id="dropdown-basic"
                >
                  {selectedLabel || "Select"}
                </Dropdown.Toggle>

                <Dropdown.Menu className="dropdown-menu customDateMenu">
                  <Dropdown.Item
                    onClick={() => {
                      setShow(false);
                      setSelectedLabel("Last 7 days");
                    }}
                  >
                    Last 7 days
                  </Dropdown.Item>

                  <Dropdown.Item
                    onClick={() => {
                      setShow(false);
                      setSelectedLabel("Last 15 days");
                    }}
                  >
                    Last 15 days
                  </Dropdown.Item>

                  <Dropdown.Item
                    onClick={() => {
                      setShow(false);
                      setSelectedLabel("Last 30 days");
                    }}
                  >
                    Last 30 days
                  </Dropdown.Item>

                  <Dropdown.Item disabled>Custom Date :</Dropdown.Item>

                  <Dropdown.Item as="div" onClick={(e) => e.stopPropagation()}>
                    <input
                      type="date"
                      className="form-control"
                      onChange={(e) => {
                        setShow(false); // close after selecting
                        setSelectedLabel(e.target.value);
                      }}
                    />
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
        </div>

        {(filterToggler || selectedLabel) && (
          <div className="filterResultsContainer">
            <div>
              <span style={{ color: "var(--color-font-primary)" }}>
                Showing Results Of{" "}
              </span>{" "}
              : &nbsp; {filterToggler ? filterToggler : ""}
              {selectedLabel ? `, ${selectedLabel}` : ""}
            </div>
            <div
              style={{ cursor: "pointer", color: "var(--color-font-primary)" }}
              onClick={handleClearFilters}
            >
              {" "}
              <span className="me-1">
                <IoClose />
              </span>
              Clear Filters
            </div>
          </div>
        )}

        {/* table  */}
        <div className="titleOrderList">Recent Transactions</div>

        <div className="dashboardTableContainer">
          <TableContainer component={Paper}>
            <Table
              // sx={{ minWidth: 650 }}
              stickyHeader
              aria-label="sticky table"
            >
              <TableHead className="dashboadTableHeader">
                <TableRow>
                  <TableCell align="left">Date</TableCell>
                  <TableCell align="left">Source</TableCell>
                  <TableCell align="left">Counterparty</TableCell>
                  <TableCell align="left">Invoice</TableCell>
                  <TableCell align="left">Order Value</TableCell>
                  <TableCell align="left">Paid</TableCell>
                  <TableCell align="left">Balance Amount</TableCell>
                  <TableCell align="left">Status</TableCell>
                  <TableCell align="left">Actions</TableCell>
                </TableRow>
              </TableHead>
              {/* <TableBody>
                {rows1.map((row) => (
                  <TableRow
                    key={row.name}
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    className="dashboardTableBody"
                  >
                    <TableCell component="th" scope="row">
                      {row.date}
                    </TableCell>
                    <TableCell align="left">{row.source}</TableCell>
                    <TableCell align="left">{row.counterParty}</TableCell>
                    <TableCell align="left">{row.invoice}</TableCell>
                    <TableCell align="left">{row.orderValue}</TableCell>
                    <TableCell align="left">{row.paid}</TableCell>
                    <TableCell align="left">{row.balance}</TableCell>
                    <TableCell
                      align="left"
                      style={{
                        color: (() => {
                          switch (row.status) {
                            case "Overdue":
                              return "#EF4444";

                            case "Pending":
                              return "#F59E0B";
                            case "Paid":
                              return "#10B981";
                            default:
                              return "var(--color-font-secondary)";
                          }
                        })(),
                      }}
                    >
                      {row.status}
                    </TableCell>
                    <TableCell align="left">
                      <IoEyeOutline
                        onClick={() => navigate("/state-view-paymentsDues")}
                        style={{ cursor: "pointer" }}
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody> */}
              <TableBody>
                <TableRow>
                  <TableCell
                    colSpan={9}
                    align="center"
                    style={{ padding: "20px" }}
                  >
                    Data Not Available
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </div>
    </div>
  );
};
